export const statusName: Record<string, string> = {
  IN_CALL: '通话中', RINGING: '正在来电', AVAILABLE: '可接',
  NOT_ACCEPTING: '不可接', UNKNOWN: '状态未知', OFFLINE: '本机不可用'
}

export function money(value: number | undefined) {
  return Number(value ?? 0).toFixed(2)
}

export function time(value: number) {
  return new Date(value).toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' })
}

export function ago(value: number, now = Date.now()) {
  if (!value) return '从未同步'
  const minutes = Math.max(0, Math.floor((now - value) / 60000))
  if (minutes < 1) return '刚刚同步'
  if (minutes < 60) return `${minutes}分钟前同步`
  return `${Math.floor(minutes / 60)}小时前同步`
}
